import {
    Box,
    Center,
    chakra,
    GridItem,
    Image,
    SimpleGrid,
    Text,
  } from '@chakra-ui/react';
  import React_icon from "../assets/react.png"
  import Redux_icon from "../assets/redux.png"
  import Javascript_icon from "../assets/javascript.png"
  import HTML_icon from "../assets/html.png"
  import CSS_icon from "../assets/css3.png"
  import Nextjs_icon from "../assets/next.js.png"
  import Chakra_icon from "../assets/chakra-ui.png"
  import Node_icon from "../assets/node-js.png"
  import express from "../assets/express.png"
  import mongodb from "../assets/mongodb.png"
  import Typescript from "../assets/typescript.png"
  
 
  
  
  
  export default function Skills() {
    return (
      <Box maxW="7xl" mx={'auto'} pt={5} px={{ base: 2, sm: 12, md: 17 }} id='skills'>
        <chakra.h1
         textAlign={'center'}
         fontSize={{base:"2xl",lg:"4xl"}}
         fontWeight={'bold'}
         bg={'teal'}
         color={'white'}
         w={'50%'}
         h='50px'
         rounded="2xl"
         m={'auto'}
         mb={'50px'}>
          Skills
        </chakra.h1>
        <SimpleGrid columns={{ base: 2, md:3, lg:4 }} spacing={{ base: 3, lg: 5 }} fontWeight={'bold'} fontSize={'2xl'} w={'80%'} m={'auto'}>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
              <Image src={HTML_icon}></Image>
              </Center>
              <Text>HTML</Text>
              </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
              <Image src={CSS_icon}></Image>
              </Center>
              <Text>CSS3</Text>
              </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
               <Image src={Javascript_icon}></Image>
               </Center>
               <Text>JavaScript</Text>
               </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'> 
              <Center>
              <Image src={React_icon}></Image>
              </Center>
              <Text>React Js</Text>
              </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
              <Image src={Redux_icon}></Image>
              </Center>
              <Text>Redux</Text>
              </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
               <Image w={"80px"} h={"80px"} bg={'white'}  src={Typescript}></Image>
               </Center>
               <Text>Typescript</Text>
              </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
               <Image bg={'white'} rounded={'full'} src={Nextjs_icon}></Image>
               </Center>
               <Text>Next Js</Text>
               </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
              <Image src={Chakra_icon}></Image>
              </Center>
              <Text>Chakra UI</Text>
              </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
              <Image src={Node_icon}></Image>
              </Center>
              <Text>Node Js</Text>
              </GridItem>  
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
              <Image src={express}></Image>
              </Center>
              <Text>Express</Text>
              </GridItem>
            <GridItem rounded={'xl'} p={5} boxShadow= 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset'>
              <Center>
              <Image src={mongodb}></Image>
              </Center>
              <Text>MongoDB</Text>
            </GridItem>
              
            
        </SimpleGrid>
      </Box>
    );
  }